export const BACKEND_DATA_QUERY = `
{  
  allsectionstypes {
    id
    sectionName
    isActive
  }
  events {
    id
    title
    description
    startDate
    endDate
    imageUrl
    meetUrl
    tags {
      id
      title
    }
    documentsLinks{
      id
      title
      link
      description
      logoUrl
      tag{
        id
        title
      }
    }
    others
    comments
  }
  visits{
    id
    title
    description
    startDate
    endDate
    imageUrl
    meetUrl
    tags {
      id
      title
    }
    documentsLinks{
      id
      title
      link
      description
      logoUrl
      tag{
        id
        title
      }
    }
    others
    comments
  }
  sessions{
    id
    title
    description
    startDate
    endDate
    imageUrl
    meetUrl
    tags {
      id
      title
    }
    documentsLinks{
      id
      title
      link
      description
      logoUrl
      tag{
        id
        title
      }
    }
    others
    comments
  }
  trainings{
    id
    title
    description
    startDate
    endDate
    imageUrl
    meetUrl
    tags {
      id
      title
    }
    documentsLinks{
      id
      title
      link
      description
      logoUrl
      tag{
        id
        title
      }
    }
    others
    comments
  }
  latestheadlines {
    id
    title
    startDate
    endDate
    link
    description
    imageUrl
  }
  videos {
    id
    title
    description
    videoLink
  }
  startups {
    id
    title
    description
    imageLink
    documentLink
    website
  }
  
  tags{
    id
    title
  }
  people {
    id
    name
    designation
    imageLink
    description
    linkedin
    instagram
    tags {
      id
      title
    }
    isActive
    batch
  }
  teamMembers{
    id
    name
    designation
    imageLink
    description
    linkedin
    instagram
    tags {
      id
      title
    }
    isActive
    batch
  }
  alumniEntrepreneurs{
    id
    name
    designation
		imageLink
    description
    linkedin
    instagram
    tags {
      id
      title
    }
    isActive
    batch
  }
  industrialMentors{
    id
    name
    designation
    imageLink
    description
    linkedin
    instagram
    tags {
      id
      title
    }
    isActive
    batch
  }
  facultyMentors{
    id
    name
    designation
    imageLink
    description
    linkedin
    instagram
    tags {
      id
      title
    }
    isActive
    batch
  }
  links {
    id
    title
    link
    description
    logoUrl
    tag{
      id
      title
    }
  }
  internships {
    id
    title
    companyLink
    description
    imageLink
    applyLink
    deadline
  }
  collaboration {
    id
    title
    description
    imageLink
    website
  }
  otherdetails{
    id
    motto
    vision
    mission
    policy
    Rules
    aboutUs
  }
}
`;
